import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-translation-tabs-item',
  templateUrl: './translation-tabs-item.component.html',
})
export class TranslationTabsItemComponent {
  @Input() title: string;
  @Input() description: string;
}
